import { render, staticRenderFns } from "./geli.vue?vue&type=template&id=294520b5"
import script from "./geli.vue?vue&type=script&lang=js"
export * from "./geli.vue?vue&type=script&lang=js"
import style0 from "./geli.vue?vue&type=style&index=0&id=294520b5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports